<script setup lang="ts">
defineOptions({
  name: "CheckoutLayout",
});
const { loadNavigationElements } = useNavigation();


const { loadNavigationElements: loadFooterNavigationElements } = useNavigation({
  type: "footer-navigation",
});
const { data: footerData } = useAsyncData("mainFooterNavigation", () => {
  return loadFooterNavigationElements({ depth: 1 });
});
provide("swNavigation-footer-navigation", footerData);

const { loadNavigationElements: loadTopNavigationElements } = useNavigation({
  type: "service-navigation",
});
const { data: topNavigationData } = useAsyncData(
  "mainServiceNavigation",
  () => {
    return loadTopNavigationElements({ depth: 1 });
  }
);
provide("swNavigation-service-navigation", topNavigationData);
</script>
<template>
  <div>
    <LayoutCheckoutHeader />
    <LayoutNotifications />
    <main class="max-w-screen-xl mx-auto">
      <slot />
    </main>
    <LayoutCheckoutFooter />
  </div>
</template>
